<div class="back-to-top" (click)="scrollToTop()" [ngClass]="{ show: show }">
    <app-icon class="arrow" [type]="'Arrow-down'"></app-icon>
    <div class="label">Top</div>
</div>
